package feature.businessConfig.event

enum class BusinessConfigEvent(val value: String) {
    CREATE("CREATE_BUSINESS_CONFIGURATION"),
    UPDATE("UPDATE_BUSINESS_CONFIGURATION"),
    RETRIEVE("RETRIEVE_BUSINESS_CONFIGURATION"),
    DELETE("DELETE_BUSINESS_CONFIGURATION"),
    RETRIEVE_ALL_CURRENCY("RETRIEVE_ALL_CURRENCY")
}